var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification"},[_c('h1',{staticClass:"title is-6 is-block"},[_vm._v("Insignias")]),_c('carousel',{attrs:{"pagination-enabled":false,"perPageCustom":[
      [320, 3],
      [480, 4] ]}},_vm._l((_vm.badges),function(item){return _c('slide',{key:item.id},[_c('BadgeImage',{attrs:{"unlocked":_vm.earnedBadges.includes(item.id),"title":item.title,"imageUrl":item.logo}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }